import { Component, OnInit } from '@angular/core';

import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HTTPService, HelperService } from 'app/services';
import { DateService } from 'app/services/date.service';
import { datetimeFormat } from 'app/constants/date-time-format';

@Component({
  selector: 'app-duplicate-vehicle-dialog',
  templateUrl: './duplicate-vehicle-dialog.component.html',
  styleUrls: ['./duplicate-vehicle-dialog.component.scss'],
})
export class DuplicateVehicleDialogComponent implements OnInit {
  data: any = {};
  customerList: any = [];
  copyExistingCustomerList: any = [];
  selectedVehicle: any = {};
  customerId: string = '';
  vehicleName: string = '';
  existingCustomerList: any = [];
  OtherVehicleCustomer: any = [];
  copyOtherVehicleCustomer: any = [];
  isLoading: boolean = false;
  isShowOnly: boolean = false;

  constructor(
    public dConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    public dataService: DataService,
    private dateService: DateService
  ) {}

  ngOnInit() {
    this.data = this.dConfig.data;
    this.customerList = [];
    this.existingCustomerList = [];
    this.OtherVehicleCustomer = [];

    this.customerList = this.data.customerList;
    this.customerId = this.data.customerId;
    this.vehicleName = this.data.vehicleName;
    this.isShowOnly = this.data.isShow;

    // Vehicle list for the selected customer
    this.customerList.forEach((customer) => {
      if (customer.customerId === this.customerId) {
        this.existingCustomerList.push(customer);
      }
    });
    this.copyExistingCustomerList = this.helperService.deepCopy(this.existingCustomerList);

    // vehciles list for other customers
    this.customerList.forEach((c) => {
      if (c.customerId !== this.customerId) {
        this.OtherVehicleCustomer.push(c);
      }
    });
    this.copyOtherVehicleCustomer = this.helperService.deepCopy(this.OtherVehicleCustomer);
  }

  handleSubmit(e, type) {
    if (type === 'newVehicle') {
      const data = { selectedVehicle: this.selectedVehicle, type };
      this.ref.close(data);
    } else if (type === 'updateVehicle') {
      const data = { selectedVehicle: this.selectedVehicle, type };
      this.selectedVehicle['vehicleCheck'] = false;
      this.ref.close(data);
    } else if (type === 'showOnly') {
      const data = { selectedVehicle: this.selectedVehicle, type };
      this.ref.close(data);
    }
  }

  closeDuplicateVehicleeModal(data: any) {
    this.ref.close({ });
  }

  handleRadioChange(type, key: any, customerIndex, vehicleIndex, event) {
    this.existingCustomerList = this.helperService.deepCopy(this.copyExistingCustomerList);
    this.OtherVehicleCustomer = this.helperService.deepCopy(this.copyOtherVehicleCustomer);

    if (type === 'existing') {
      this.existingCustomerList[customerIndex].vehicles[vehicleIndex][key] = event;
      this.existingCustomerList[customerIndex].vehicles[vehicleIndex]['customerName'] = this.existingCustomerList[customerIndex].customerName;
      this.selectedVehicle = this.existingCustomerList[customerIndex].vehicles[vehicleIndex];
    } else if (type === 'other') {
      this.OtherVehicleCustomer[customerIndex].vehicles[vehicleIndex][key] = event;
      this.OtherVehicleCustomer[customerIndex].vehicles[vehicleIndex]['customerName'] = this.OtherVehicleCustomer[customerIndex].customerName;
      this.selectedVehicle = this.OtherVehicleCustomer[customerIndex].vehicles[vehicleIndex];
    }
  }
}
